"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const luxon_1 = require("luxon");
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const classnames_1 = __importDefault(require("classnames"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const DownshiftField_1 = __importDefault(require("components/QuickenControls/DownshiftField"));
const utils_1 = require("./utils");
const RecrVirtualField = ({ classes, virtualFrequency, virtualRecurrence, dueOnValue, formikProps, setNewVirtualRecurrence, isTypeGrossPaycheck, monthsIntervalMap, isQWinDataset, }) => {
    const currentFrequency = React.useRef(virtualFrequency);
    const handleFrequencyChange = (newFrequency) => {
        if (isQWinDataset
            && currentFrequency.current === scheduledTransactionsUtils_1.frequencyAliasTypes.quarterlyQuicken
            && newFrequency === scheduledTransactionsUtils_1.frequencyAliasTypes.monthlyQuicken) {
            formikProps.setFieldValue('virtualRecurrence.interval', 1);
        }
        currentFrequency.current = newFrequency;
    };
    React.useEffect(() => {
        handleFrequencyChange(virtualFrequency);
    }, [virtualFrequency]); // eslint-disable-line react-hooks/exhaustive-deps
    const dueOnDate = (dueOnValue && luxon_1.DateTime.fromFormat(dueOnValue, utils_1.US_DATE_FORMAT)) || luxon_1.DateTime.local();
    const daysInMonth = dueOnDate && dueOnDate.isValid ? dueOnDate.daysInMonth : 31;
    const sortItems = (a, b) => (parseInt(a, 10) - parseInt(b, 10));
    const onSelected = (name, value) => formikProps.setFieldValue(name, value);
    const parseDate = (dateStr, year) => (dateStr && dateStr.length === 5 ? `${dateStr}/${year}` : dateStr);
    const onWeeklyDateChange = (name, value) => {
        // check newDate is not in the past
        let newDueOnDate = dueOnDate.set({ weekday: utils_1.dayMap[value] });
        newDueOnDate = newDueOnDate >= dueOnDate ? newDueOnDate : newDueOnDate.plus({ weeks: 1 });
        onSelected(name, value);
        onSelected('dueOn', newDueOnDate.toLocaleString(luxon_1.DateTime.DATE_SHORT));
    };
    const onMonthlyDateChange = (name, value) => {
        onSelected(name, value);
        onSelected('dueOn', dueOnDate.set({ day: parseInt(value, 10) }).toLocaleString(luxon_1.DateTime.DATE_SHORT));
    };
    const getDatesForQuarterlyReminder = () => {
        const dateObj = luxon_1.DateTime.fromFormat(formikProps.values.dueOn, utils_1.US_DATE_FORMAT);
        const date = dateObj.toFormat(utils_1.LONG_MONTH_DATE_FORMAT);
        const date2 = dateObj.plus({ months: 3 }).toFormat(utils_1.LONG_MONTH_DATE_FORMAT);
        const date3 = dateObj.plus({ months: 6 }).toFormat(utils_1.LONG_MONTH_DATE_FORMAT);
        const date4 = dateObj.plus({ months: 9 }).toFormat(utils_1.LONG_MONTH_DATE_FORMAT);
        return date.concat(', ', date2, ', ', date3, ', ', date4);
    };
    const onTwiceAMonthDateChange = (changeIndex) => (name, value) => {
        const hasByMonthDay = !(0, utils_1.hasByMonthDayOrLastDay)(formikProps.values.virtualRecurrence);
        const byMonthValue = !hasByMonthDay ? virtualRecurrence.byMonthDayOrLastDay[0] : virtualRecurrence.byMonthDay[0];
        const firstDay = changeIndex === 0 ? value : byMonthValue;
        const firstDate = dueOnDate.set({ day: firstDay });
        let newValue = value;
        if (hasByMonthDay && value >= 28) {
            const endOfMonth = luxon_1.DateTime.fromFormat(formikProps.values.dueOn, utils_1.US_DATE_FORMAT).endOf('month').day;
            newValue = -(endOfMonth - newValue);
        }
        onSelected(name, newValue);
        onSelected('dueOn', firstDate.toLocaleString(luxon_1.DateTime.DATE_SHORT));
    };
    const onTwiceAYearDateChange = (changeIndex) => (name, date) => {
        const dates = [...virtualRecurrence.byDates];
        if (changeIndex === 1) {
            dates[0] = dueOnDate;
            dates[1] = date;
            if (dates[0] >= dates[1] && dates[0].year === dates[1].year) {
                dates.reverse();
            }
            onSelected('dueOn', dates[0].toLocaleString(luxon_1.DateTime.DATE_SHORT));
            onSelected('virtualRecurrence.byDates[0]', dates[0].toFormat(utils_1.SHORT_DATE_FORMAT));
            onSelected('virtualRecurrence.byDates[1]', dates[1].toFormat(utils_1.SHORT_DATE_FORMAT));
        }
        else if (date.toFormat(utils_1.SHORT_DATE_FORMAT) !== dates[0]) {
            setNewVirtualRecurrence({ dueOnValue: date, overwriteIntervalFlag: true });
            onSelected(name, date.toFormat(utils_1.SHORT_DATE_FORMAT));
        }
    };
    const renderRecuerrenceDateField = (args) => (<formik_1.Field name={args.name} validate={(value) => {
            let errorMessage = '';
            if (!value || !value.length) {
                errorMessage = 'required';
            }
            else if (!luxon_1.DateTime.fromFormat(value, utils_1.SHORT_DATE_FORMAT).isValid) {
                errorMessage = 'invalid';
            }
            return errorMessage;
        }}>
      {({ field: fieldData, form: { _values, touched, errors } }) => {
            const field = Object.assign({}, fieldData);
            if (args.fixValue) {
                field.value = args.fixValue(field.value);
            }
            const date = luxon_1.DateTime.fromFormat(field.value, utils_1.US_DATE_FORMAT);
            const selected = date.isValid ? date : luxon_1.DateTime.local();
            return (<div className={classes.datePickerWrapper}>
            <react_datepicker_1.default disabled={args === null || args === void 0 ? void 0 : args.isTypeGrossPaycheck} id={args.id} selected={selected.toJSDate()} onChange={(jsDate, e) => (args.onChange(field.name, (e.key ? date : luxon_1.DateTime.fromJSDate(new Date(jsDate)))))} onClickOutside={() => (args.onChange(field.name, date))} onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        e.stopPropagation();
                    }
                }} minDate={args.minDate} maxDate={args.maxDate} popperPlacement={args.id === 'byDates-twice-year-first' ? 'bottom-start' : 'bottom-end'} allowSameDay disabledKeyboardNavigation customInputRef="inputRef" customInput={<TextField_1.default InputProps={Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, autoComplete: 'off' })} InputLabelProps={{
                        classes: { root: classes.ellipser },
                    }} label={args.label} margin="dense" fullWidth error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)}/>}/>
          </div>);
        }}
    </formik_1.Field>);
    const renderRecurrenceTextField = (args) => (<formik_1.Field name={args.name}>
      {({ field: fieldData }) => {
            const field = Object.assign({}, fieldData);
            if (args.fixValue) {
                field.value = args.fixValue(field.value);
            }
            return <TextField_1.default {...field} id={args.id} label={args.label} InputProps={{
                    classes: {
                        underline: classes.underlineOverride,
                    },
                    readOnly: args.readOnly,
                    autoComplete: 'off',
                }} margin="dense" fullWidth disabled={args.isTypeGrossPaycheck}/>;
        }}
    </formik_1.Field>);
    const renderRecurrenceDownshiftField = (args) => {
        let items = args.itemMap;
        if (args.sortItems) {
            items = items.sort(args.sortItems);
        }
        return (<formik_1.Field name={args.name} validate={(value) => `${value}` && `${value}`.length > 0 ? undefined : 'required'}>
        {({ field: fieldData, form: { values, touched, errors } }) => {
                const field = Object.assign({}, fieldData);
                if (args.fixValue) {
                    field.value = args.fixValue(field.value, values.virtualRecurrence);
                }
                return <DownshiftField_1.default key={`${args.id}-${(0, lodash_1.get)(values, field.name)}`} initialItemSelected={`${field.value}`} onSelected={(day) => args.onSelected(field.name, day)} items={[...items.keys()]} itemToString={(item) => items.get(item)} textFieldProps={{
                        InputProps: Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, disabled: args === null || args === void 0 ? void 0 : args.isTypeGrossPaycheck }),
                        id: args.id,
                        label: args.label,
                        margin: 'normal',
                        fullWidth: true,
                        autoComplete: 'off',
                        error: Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)),
                        helperText: (0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name),
                    }} lightWeight/>;
            }}
      </formik_1.Field>);
    };
    const renderInterval = (itemMap, id, label = 'Every') => renderRecurrenceDownshiftField({
        sortItems,
        itemMap,
        id,
        label,
        name: 'virtualRecurrence.interval',
        onSelected: (name, interval) => onSelected(name, parseInt(interval, 10)),
        isTypeGrossPaycheck,
    });
    let singleColumn;
    let leftColumn;
    let rightColumn;
    switch (virtualFrequency) {
        case scheduledTransactionsUtils_1.frequencyAliasTypes.dayQuicken:
            leftColumn = (<formik_1.Field name="virtualRecurrence.interval" margin="dense" validate={(value) => {
                    if (!value || (value === null || value === void 0 ? void 0 : value.length) <= 0)
                        return 'required';
                    const onlyNums = +value;
                    if (Number.isNaN(onlyNums) || onlyNums < 1 || onlyNums > 365) {
                        return 'Please enter numeric value between 1 and 365';
                    }
                    return null;
                }}>
          {({ field: fieldData, form: { _values, touched, errors } }) => {
                    const field = Object.assign({}, fieldData);
                    return (<TextField_1.default {...field} id="intervalDay" label="Every" InputProps={{
                            disabled: isTypeGrossPaycheck,
                            classes: {
                                underline: classes.underlineOverride,
                            },
                            autoComplete: 'off',
                            endAdornment: (<InputAdornment_1.default position="end">
                      day{(field === null || field === void 0 ? void 0 : field.value) > 1 && 's'}
                    </InputAdornment_1.default>),
                        }} onChange={(e) => {
                            formikProps.setFieldValue(field.name, e.target.value);
                        }} error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)}/>);
                }}
        </formik_1.Field>);
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.weeklyQuicken:
            leftColumn = renderInterval(utils_1.weeksIntervalMap, 'interval-weekly');
            rightColumn = renderRecurrenceDownshiftField({
                name: 'virtualRecurrence.byDay[0]',
                onSelected: onWeeklyDateChange,
                itemMap: utils_1.byDayMap,
                id: 'byDay-weekly',
                label: 'Day',
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.every2WeeksQuicken:
            singleColumn = renderRecurrenceDownshiftField({
                name: 'virtualRecurrence.byDay[0]',
                onSelected: onWeeklyDateChange,
                itemMap: utils_1.byDayMap,
                id: 'byDay-biWeekly',
                label: 'Every 2 weeks on',
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.twiceAMonthQuicken:
            {
                const fixValue = (value, virtualRecurrenceObj) => {
                    if (value <= 0 && !(0, utils_1.hasByMonthDayOrLastDay)(virtualRecurrenceObj)) {
                        const endOfMonth = luxon_1.DateTime.fromFormat(formikProps.values.dueOn, utils_1.US_DATE_FORMAT).endOf('month').day;
                        return value + endOfMonth;
                    }
                    return value;
                };
                singleColumn = renderInterval(monthsIntervalMap, 'interval-twice-month');
                leftColumn = renderRecurrenceDownshiftField({
                    name: (0, utils_1.hasByMonthDayOrLastDay)(formikProps.values.virtualRecurrence) ? 'virtualRecurrence.byMonthDayOrLastDay[0]' : 'virtualRecurrence.byMonthDay[0]',
                    onSelected: onTwiceAMonthDateChange(0),
                    sortItems,
                    itemMap: (0, utils_1.getByMonthDaysMap)(daysInMonth),
                    id: 'byMonthDay-twice-month-first',
                    fixValue,
                    label: 'First on',
                    isTypeGrossPaycheck,
                });
                rightColumn = renderRecurrenceDownshiftField({
                    name: (0, utils_1.hasByMonthDayOrLastDay)(formikProps.values.virtualRecurrence) ? 'virtualRecurrence.byMonthDayOrLastDay[1]' : 'virtualRecurrence.byMonthDay[1]',
                    onSelected: onTwiceAMonthDateChange(1),
                    sortItems,
                    itemMap: (0, utils_1.getByMonthDaysMap)(daysInMonth),
                    id: 'byMonthDay-twice-month-second',
                    fixValue,
                    label: 'Second on',
                    isTypeGrossPaycheck,
                });
            }
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.everyFourWeeksQuicken:
            singleColumn = renderRecurrenceDownshiftField({
                name: 'virtualRecurrence.byDay[0]',
                onSelected: onWeeklyDateChange,
                itemMap: utils_1.byDayMap,
                id: 'byDay-four-Weekly',
                label: 'Every 4 weeks on',
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.monthlyQuicken:
            leftColumn = renderInterval(monthsIntervalMap, 'interval-monthly');
            rightColumn = renderRecurrenceDownshiftField({
                name: (0, utils_1.hasByMonthDayOrLastDay)(formikProps.values.virtualRecurrence) ? 'virtualRecurrence.byMonthDayOrLastDay[0]' : 'virtualRecurrence.byMonthDay[0]',
                onSelected: onMonthlyDateChange,
                sortItems,
                itemMap: (0, utils_1.getByMonthDaysMap)(daysInMonth),
                id: 'byMonthDay-monthly',
                label: 'Day',
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.quarterlyQuicken:
            singleColumn = renderRecurrenceTextField({
                name: 'virtualOnDates',
                id: 'onDates-quarterly',
                label: 'On Dates',
                readOnly: true,
                fixValue: getDatesForQuarterlyReminder,
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.twiceAYearQuicken:
            {
                const transactionYear = (dueOnDate && dueOnDate.year) || luxon_1.DateTime.local().year;
                const fixValue = (position) => (value) => {
                    const dates = [...virtualRecurrence.byDates].map((date) => luxon_1.DateTime.fromFormat(date, utils_1.SHORT_DATE_FORMAT).month + 1);
                    const increaseYear = position === 1 && (dates[0] >= 6) && (dates[1] <= 6); // When is second date, and first date is in second half of the year
                    return value && parseDate(value, increaseYear ? transactionYear + 1 : transactionYear);
                };
                singleColumn = renderInterval(utils_1.yearsIntervalMap, 'interval-twice-year');
                leftColumn = renderRecuerrenceDateField({
                    name: 'virtualRecurrence.byDates[0]',
                    onChange: onTwiceAYearDateChange(0),
                    id: 'byDates-twice-year-first',
                    label: 'First on',
                    fixValue: fixValue(0),
                    minDate: luxon_1.DateTime.local().toJSDate(),
                    isTypeGrossPaycheck,
                });
                rightColumn = renderRecuerrenceDateField({
                    name: 'virtualRecurrence.byDates[1]',
                    onChange: onTwiceAYearDateChange(1),
                    id: 'byDates-twice-year-second',
                    label: 'Second on',
                    fixValue: fixValue(1),
                    minDate: luxon_1.DateTime.local().toJSDate(),
                    isTypeGrossPaycheck,
                });
            }
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.toPayEstimatedTaxesQuicken:
            singleColumn = renderRecurrenceTextField({
                name: 'virtualOnDates',
                id: 'onDates-tax-pay',
                label: 'On Dates',
                readOnly: true,
                fixValue: () => {
                    var _a;
                    const dates = (_a = virtualRecurrence === null || virtualRecurrence === void 0 ? void 0 : virtualRecurrence.byDates) === null || _a === void 0 ? void 0 : _a.map((date) => luxon_1.DateTime.fromFormat(date, utils_1.SHORT_DATE_FORMAT));
                    const adjustedDates = dates.map((date) => {
                        if (date.month === 1 && date.day === 15) {
                            return date.plus({ year: 1 });
                        }
                        return date;
                    });
                    return adjustedDates.sort().map((date) => date.toFormat(utils_1.US_DATE_FORMAT)).join(', ');
                },
                isTypeGrossPaycheck,
            });
            break;
        case scheduledTransactionsUtils_1.frequencyAliasTypes.yearlyQuicken:
            singleColumn = renderInterval(utils_1.yearsIntervalMap, 'interval-yearly');
            break;
        default: break;
    }
    const leftColumnClass = (0, classnames_1.default)({ [classes.inputLeft]: Boolean(rightColumn) });
    return (<>
      {singleColumn && (<Grid_1.default container>
          {singleColumn && <Grid_1.default item xs>{singleColumn}</Grid_1.default>}
        </Grid_1.default>)}
      {(leftColumn || rightColumn) && (<Grid_1.default container>
          {leftColumn && <Grid_1.default item xs={6} md className={leftColumnClass}>{leftColumn}</Grid_1.default>}
          {(leftColumn && rightColumn) && <Grid_1.default item xs={6} md lg className={classes.inputRight}>{rightColumn}</Grid_1.default>}
        </Grid_1.default>)}
    </>);
};
exports.default = RecrVirtualField;
